import { API_V1 } from './APIs/APIv1';
import { call } from './engagement';

/**
 * The two optional customer consents (document ids `marketing-email`, `ad-measurement`).
 * Withdrawing sets `withdrawnAt` on the API side; granting again adds a new record.
 */

/** What GET/PUT /consents answer per consent. */
export interface ConsentStateResponse {
  granted: boolean;
  acceptedAt?: string;
  withdrawnAt?: string;
  version?: string;
}

/** Flattened for the switches: on/off plus the two timestamps. */
export interface CustomerConsents {
  marketingEmail: boolean;
  adMeasurement: boolean;
  marketingEmailAt?: string | null;
  adMeasurementAt?: string | null;
  marketingEmailWithdrawnAt?: string | null;
  adMeasurementWithdrawnAt?: string | null;
}

export const toCustomerConsents = (d: { marketingEmail?: ConsentStateResponse; adMeasurement?: ConsentStateResponse }): CustomerConsents => ({
  marketingEmail: d?.marketingEmail?.granted === true,
  adMeasurement: d?.adMeasurement?.granted === true,
  marketingEmailAt: d?.marketingEmail?.acceptedAt ?? null,
  adMeasurementAt: d?.adMeasurement?.acceptedAt ?? null,
  marketingEmailWithdrawnAt: d?.marketingEmail?.withdrawnAt ?? null,
  adMeasurementWithdrawnAt: d?.adMeasurement?.withdrawnAt ?? null,
});

export const getConsents = () => call<Parameters<typeof toCustomerConsents>[0]>(() => API_V1.get('/consents')).then(toCustomerConsents);

export const updateConsents = (patch: { marketingEmail?: boolean; adMeasurement?: boolean }) =>
  call<Parameters<typeof toCustomerConsents>[0]>(() => API_V1.put('/consents', patch)).then(toCustomerConsents);
